import React, { Component } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import Iframe from "react-iframe";
import { Link } from "react-router-dom";
import axios from "axios";
import "./css/footer.css";

const handle = () => {
  window.scroll(0, 0);
};

// function onChange(value) {
//     console.log("Captcha value:", value)
//   }

class Footer extends Component {
  state = {
    name: "",
    email: "",
    mobile_number: "",
    comment: "",
    validatename: false,
    validateemail: false,
    validatephone: false,
    validatecomment: false,
    loadIframe: false,
  };
  onChange = (e) => {
    this.setState({ ...this.state, [e.target.name]: e.target.value });

    switch (e.target.name) {
      case "name":
        // console.log(e.target.value);
        if (e.target.value !== 0) {
          this.setState({ validatename: true });
        }
        break;
      case "email":
        // console.log(e.target.value);

        if (e.target.value !== 0) {
          this.setState({ validateemail: true });
        }
        break;

      case "mobile_number":
        // console.log(e.target.value);

        if (e.target.value !== 0) {
          this.setState({ validatephone: true });
        }
        break;

      case "comment":
        if (e.target.value !== 0) {
          this.setState({ validatecomment: true });
        }
        break;

      default:
        break;
    }
    // console.log(e.target.value)
  };

  onSubmit = async (event) => {
    event.preventDefault();

    if (
      !this.state.validatename ||
      !this.state.validateemail ||
      !this.state.validatephone ||
      !this.state.validatecomment
    ) {
      alert("Please make sure all fields are filled");
      return;
    }

    let recaptchaToken = "";
    if (this.props.executeRecaptcha) {
      recaptchaToken = await this.props.executeRecaptcha("contact_form");
    }

    let msg =
      "From site : Aiplexads.com\nName: " +
      this.state.name +
      "\n Email: " +
      this.state.email +
      "\n Mobile Number: " +
      this.state.mobile_number +
      "\n Comment: " +
      this.state.comment;
    const data = {
      name: this.state.name,
      email: this.state.email,
      mobile_number: this.state.mobile_number,
      comment: msg,
      subject: "Website Form Submission (www.aiplexads.com)",
      recaptchaToken,
    };

    axios.post(process.env.REACT_APP_MAIL_API_URL, data).then((res) => {
      document.getElementById("myform").reset();
      alert("Message Sent Successfully");
      this.setState({
        validatecomment: false,
        validateemail: false,
        validatename: false,
        validatephone: false,
      });
    });
  };

  //Code to increase pagespeed, lazyloading of map iframe
  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
  handleScroll = () => {
    if (
      window.innerHeight + window.scrollY >=
      document.documentElement.scrollHeight / 2
    ) {
      this.setState({ loadIframe: true });
    }
  };

  render() {
    const { loadIframe } = this.state;

    return (
      <div className="container1">
        <div _ngcontent-qht-c34="" className="container1 hrline1"></div>
        <div className="" id="contactus">
          {loadIframe && (
            <Iframe
              url="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7777.483417018082!2d77.51366393488773!3d12.924315500000013!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3f39de1c02f5%3A0x69d7777f81da6f40!2sAiplex%20Software%20Private%20Limited!5e0!3m2!1sen!2sin!4v1605612007134!5m2!1sen!2sin"
              width="100%"
              height="400px"
              frameborder="0"
              style={{ border: "0" }}
              allowfullscreen=""
              aria-hidden="false"
              tabindex="0"
            ></Iframe>
          )}
        </div>
        <div
          style={{ backgroundColor: "#e4e4e4" }}
          id="contact"
          className="container1"
        >
          <div className="row py-5 px-3">
            <div className="col-md-5 padlf">
              <h6 className="pb-4">
                <strong>Drop us a line</strong>
              </h6>
              <form className="formtext" id="myform">
                <div className="form-group">
                  <input
                    className="form-control inpt"
                    type="text"
                    required
                    name="name"
                    placeholder="Name"
                    onChange={this.onChange}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="form-control inpt"
                    required
                    type="email"
                    name="email"
                    placeholder="Email"
                    onChange={this.onChange}
                  />
                </div>
                <div className="form-group">
                  <input
                    className="form-control inpt"
                    required
                    type="text"
                    name="mobile_number"
                    minLength="10"
                    placeholder="Phone Number"
                    onChange={this.onChange}
                  />
                </div>
                <div className="form-group">
                  <textarea
                    className="form-control inpt"
                    required
                    type=""
                    name="comment"
                    placeholder="Your Comment"
                    onChange={this.onChange}
                  ></textarea>
                </div>
                <button
                  type="button"
                  className="btn btn-color mt-2"
                  onClick={this.onSubmit}
                >
                  <strong>Send a Message</strong>
                </button>
              </form>
            </div>
            <div className="col-md-7">
              <div className="row ">
                {/* <div className="col-md-1"></div> */}
                <div className="col-md-4 pt-4 mt-3">
                  <p
                    className="first-letter pb-1 "
                    style={{ fontWeight: "bold" }}
                  >
                    Registered Office
                  </p>
                  <p>
                    <span itemprop="streetAddress">
                      91A, N Cube Centre, Ideal Homes Circle,
                    </span>
                    <span itemprop="addressLocality">
                      {" "}
                      RR Nagar, Bengaluru,
                    </span>
                    <span itemprop="addressRegion"> Karnataka</span>
                    <span itemprop="postalCode"> 560098</span>
                  </p>
                </div>
                <div className="col-md-4 pt-4 mt-3 mx-auto">
                  <p
                    className="first-letter pb-1"
                    style={{ fontWeight: "bold" }}
                  >
                    Sitemap
                  </p>
                  <div className="">
                    <a
                      className="pointer linkx colorChange"
                      href="https://www.aiplexantipiracy.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Antipiracy
                    </a>
                    <br />
                  </div>
                  <div className="" style={{ marginRight: "-30px" }}>
                    <a
                      className="pointer linkx colorChange"
                      href="https://www.aiplexorm.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Online Reputation Management
                    </a>
                    <br />
                  </div>
                  <div className="">
                    <a
                      className="pointer linkx colorChange"
                      href="https://www.aiplexdigital.com/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Digital Marketing
                    </a>
                    <br />
                  </div>

                  {/* <div className="pb-2">
                        <a className="pointer linkx colorChange" href="https://www.aiplexads.com/" target="_blank" rel="noreferrer"> Online advertising</a>
                        </div> */}
                </div>
                <div className="col-md-3 pt-4 mt-3 ">
                  <p
                    className="first-letter pb-1"
                    style={{ fontWeight: "bold" }}
                  >
                    Legal
                  </p>
                  <p>
                    <Link
                      to="/cookies"
                      onClick={handle}
                      className="pointer colorChange  linkx "
                    >
                      {" "}
                      Cookies Policy
                    </Link>
                    <br />
                    <Link
                      to="/terms-condition"
                      onClick={handle}
                      className="pointer colorChange  linkx "
                    >
                      Terms and Conditions
                    </Link>
                    <br />
                    <Link
                      to="/privacy-policy"
                      onClick={handle}
                      className="pointer colorChange linkx "
                    >
                      Privacy Policy
                    </Link>
                  </p>
                </div>
              </div>

              <div className="row mtop ">
                {/* <div className="col-md-1"></div> */}
                <div className="col-md-4 ">
                  <p>
                    <a
                      href="https://www.instagram.com/aiplexsoftware/"
                      target="_blank"
                      title=" Instagram/aiplexsoftware "
                      class="fa fa-instagram ficon ml-0"
                    ></a>
                    <a
                      href="https://www.facebook.com/aiplexsoftware"
                      target="_blank"
                      title=" Facebook/Aiplex "
                      class="fa fa-facebook ficon"
                    ></a>
                    <a
                      href="https://twitter.com/aiplexsoftware"
                      target="_blank"
                      title=" Twitter/AiPlex Software Pvt. Ltd. "
                      class="fa fa-twitter ficon"
                    ></a>
                    <a
                      href="https://www.youtube.com/channel/UCKZsdWVRrTjzzoMbYmnCgtg"
                      target="_blank"
                      title=" Youtube/AiPlex Software Pvt Ltd. "
                      class="fa fa-youtube-play ficon"
                    ></a>
                    <a
                      href="https://www.linkedin.com/company/aiplexsoftware"
                      target="_blank"
                      title=" LinkedIn/AiPlex Software Pvt. Ltd. "
                      class="fa fa-linkedin ficon"
                    ></a>
                    <a
                      href="https://in.pinterest.com/aiplexdigital/"
                      target="_blank"
                      title=" Pintrest/AiPlex "
                      class="fa fa-pinterest ficon"
                    ></a>
                  </p>
                </div>
                <div className="col-md-4 mx-auto">
                  <p className="ftext">
                    <i class="fa fa-copyright " aria-hidden="true"></i> {new Date().getFullYear()}{" "}
                    AiPlex. All Rights Reserved
                  </p>
                </div>
                <div className="col-md-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function FooterWithRecaptcha(props) {
  const { executeRecaptcha } = useGoogleReCaptcha();
  return <Footer {...props} executeRecaptcha={executeRecaptcha} />;
}

export default FooterWithRecaptcha;
